import type { GetNotificationInputDto, NotificationOutputDto } from './dtos/models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { Gift } from '../gifts/models';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  apiName = 'Default';
  

  deleteNotifiInProcessImporWishlistById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/notification/${id}/notifi-in-process-impor-wishlist`,
    },
    { apiName: this.apiName,...config });
  

  getAllByCurrentUser = (input: GetNotificationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<NotificationOutputDto>>({
      method: 'GET',
      url: '/api/app/notification/by-current-user',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  sendNotificationGiftDeliverdByGift = (gift: Gift, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/notification/send-notification-gift-deliverd',
      body: gift,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
